import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../Button';
import { t } from '@/core/localization';
/**
 * To be used inside dialogs as default button for cancel routine.
 *
 * `tabIndex` property is set to `-1` by default, `Escape` button should be used in case of keyboard key press close.
 */
const DialogCancelButton = ({ children, disabled, onClick }) => {
    return (_jsx(Button, { variant: "outlined", onClick: onClick, disabled: disabled, tabIndex: -1, children: children ?? t('cancel.label') }));
};
export { DialogCancelButton };
